import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export default function Breadcrumb({ items = [] }) {
  return (
    <nav aria-label="Breadcrumb" className="text-sm text-forest/60" data-testid="breadcrumb">
      <ol className="flex items-center gap-1.5 flex-wrap">
        <li className="flex items-center gap-1.5">
          <Link to="/" className="hover:text-forest inline-flex items-center gap-1"><Home className="w-3.5 h-3.5" /> Home</Link>
        </li>
        {items.map((it, i) => (
          <li key={i} className="flex items-center gap-1.5">
            <ChevronRight className="w-3.5 h-3.5 text-forest/40" />
            {i === items.length - 1 || !it.path ? (
              <span className="text-forest" aria-current="page">{it.name}</span>
            ) : (
              <Link to={it.path} className="hover:text-forest">{it.name}</Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
